export default "__VITE_ASSET__9c838a19__"